<template>
  <div class="banners"
       :style="{ 'background': 'url(' + banner + ') no-repeat center', 'background-size': '100% 500px;'}">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div v-if="activeIndex == 'Home'" class="swiper-slide">
          <div class="Home_Content">
            <p class="title">苏州瑞鹏信息技术有限公司</p>
            <p class="text">
              专注于移动互联网商务服务和大数据资源整合、应用、开发、服务和运营的高新技术企业，专业提供搭建大数据应用与服务平台，以实现数据挖掘、数据整理、大数据分析、精准营销、跨领域数据融合、供应链重组与整合等各方面应用。</p>
            <router-link to="About_Us" tag="span" class="btn_about_us">关于我们</router-link>
          </div>
        </div>
        <div v-if="activeIndex == 'Technology_Services'" class="swiper-slide">
          <div class="Technology_Services_Content">
            <p class="title">技术与服务</p>
            <p class="text">TEACHNOLOGY AND SERVICES</p>
          </div>
        </div>
        <div v-if="activeIndex == 'Big_Data'" class="swiper-slide">
          <div class="Big_Data_Content">
            <p class="title">大数据研究所</p>
            <p class="text">INSTITUTE OF BIG DATA</p>
          </div>
        </div>
        <div v-if="activeIndex == 'About_Us'" class="swiper-slide">
          <div class="About_Us_Content">
            <p class="title">关于我们</p>
            <p class="text">ABOUT US</p>
          </div>
        </div>
        <div v-if="activeIndex == 'Contact_Us'" class="swiper-slide">
          <div class="Contact_Us_Content">
            <p class="title">联系我们</p>
            <p class="text">CONTACT US</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper/dist/js/swiper.js'
  import {mapState} from 'vuex';

  export default {
    name: 'Banners',
    props: ['banner'],
    data() {
      return {}
    },
    computed: {
      ...mapState({
        activeIndex: state => state.activeIndex
      }),
    },
    mounted() {
      var mySwiper = new Swiper('.banners .swiper-container', {
        autoplay: false,
        loop: false,
        simulateTouch: false
      })
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .banners {
    width: 100%;
    height: 500px;
    margin-top: 60px;

    .swiper-container {
      width: 1200px;

      .Home_Content {
        width: 680px;
        color: #fff;
        margin-left: 80px;
        .title {
          font-size: 48px;
          text-align: left;
          margin: 70px 0 0;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }
        .text {
          text-align: left;
          margin: 30px 0 0;
          letter-spacing: 0.6px;
          font-size: 20px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 40px;
        }
        .btn_about_us {
          width: 192px;
          height: 60px;
          display: block;
          line-height: 56px;
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 1);
          border-radius: 8px;
          background-color: transparent;
          margin-top: 54px;
          font-size: 28px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          outline: none;
          text-align: center;
          cursor: pointer;
        }
      }

      .Technology_Services_Content,
      .Big_Data_Content,
      .About_Us_Content,
      .Contact_Us_Content {
        p {
          margin: 0;
          text-align: center;
        }
        .title {
          height:75px;
          font-size:72px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(255,255,255,1);
          margin-top: 205px;
          letter-spacing: 15px;
        }

        .text {
          height:50px;
          font-size:40px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(255,255,255,1);
          margin-top: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Banners.vue